const initialState = () => ({
  slack: null,
  msTeams: null
})

export default api => ({
  state: initialState,

  getters: {
    slackState: state => state.slack,
    msTeamsState: state => state.msTeams
  },

  mutations: {
    updateSlackState: (state, data) => {
      state.slack = data
    },

    updateMsTeamsState: (state, data) => {
      state.msTeams = data
    },

    resetIntegrations: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    slackState: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      const result = await api.slackState(slug)
      commit('updateSlackState', result)
    },

    msTeamsState: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      const result = await api.msTeamsState(slug)
      commit('updateMsTeamsState', result)
    },

    clear: ({ commit }) => {
      commit('resetIntegrations')
    }
  }
})
